import { Segment_Upload_File_Status, Segment_Upload_Mode } from '@occc/graphql';

export const labelByUploadFilesStatus: Record<Segment_Upload_File_Status, string> = {
  [Segment_Upload_File_Status.Completed]: 'Completed',
  [Segment_Upload_File_Status.Failed]: 'Failed',
  [Segment_Upload_File_Status.Processing]: 'Processing Segment',
  [Segment_Upload_File_Status.Pending]: 'Pending',
  [Segment_Upload_File_Status.AudienceUpdatePending]: 'Audience Update Pending',
  [Segment_Upload_File_Status.AudienceUpdating]: 'Audience Updating',
};

export const labelByUploadFileMode: Record<Segment_Upload_Mode, string> = {
  [Segment_Upload_Mode.Add]: 'Add',
  [Segment_Upload_Mode.Remove]: 'Remove',
  [Segment_Upload_Mode.Overwrite]: 'Overwrite',
};

export const SEGMENT_CSV_FILES_PAGE_SIZE = 10;
export const SEGMENT_CSV_FILES_BEFORE_PARAM = 'before';
export const SEGMENT_CSV_FILES_AFTER_PARAM = 'after';

const BYTES_PER_MB = 1024 * 1024;

export const SEGMENT_UPLOAD_MAX_FILE_SIZE_MB = 500;
export const SEGMENT_UPLOAD_MAX_FILE_SIZE_BYTES = SEGMENT_UPLOAD_MAX_FILE_SIZE_MB * BYTES_PER_MB;
export const SEGMENT_UPLOAD_FILE_SIZE_ERROR = `File size shouldn't exceed ${SEGMENT_UPLOAD_MAX_FILE_SIZE_MB}MB`;

export const POLLING_INTERVAL_MS = 5000;
export const MEMBERSHIP_COUNT_POLL_TIMEOUT_MS = 120_000;
